import { render, staticRenderFns } from "./d2-container-full.vue?vue&type=template&id=34e5541e&"
import script from "./d2-container-full.vue?vue&type=script&lang=js&"
export * from "./d2-container-full.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "d2-container-full.vue"
export default component.exports